import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { ApiProvider } from '@/lib/api-context';
import { queryClient } from '@/lib/query';
import { AppRouter } from '@/router';
import { RealtimeDebugOverlay } from '@/ui/RealtimeDebugOverlay';

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ApiProvider>
        <BrowserRouter>
          <AppRouter />
          <RealtimeDebugOverlay />
        </BrowserRouter>
      </ApiProvider>
    </QueryClientProvider>
  );
}
